const data = JSON.parse(localStorage.getItem("Data"));

const releaseNotesData = (type) => {
  // Remove all components that repeat themselves more than once and sort them in alphabetical order.
  const components = [...new Set(data.map((name) => name.Component))].sort((a, b) => a.localeCompare(b));

  const notesData = components.map((component) => {
    const devOnlyNotes = [];
    const notes = [];

    data.forEach((item) => {
      if (item.Component === component) {
        const { IssueType, ReleaseNotes, InternalOnly } = item;
        if (ReleaseNotes.includes("DEV ONLY") || ReleaseNotes.includes("Dev Only") || ReleaseNotes.includes("DevOnly") || InternalOnly) {
          devOnlyNotes.push(item);
        } else if (IssueType.includes(type)) {
          notes.push({ IssueType, ReleaseNotes });
        }
      }
    });

    return {
      component,
      devOnlyNotes,
      notes,
    };
  });

  return notesData;
};

export default releaseNotesData;
